// WhatsApp usernames arrive with or without a leading "@" (webhooks, agents typing them).
// Store and edit them bare; show them with a single "@".
export const normalizeWhatsAppUsername = value =>
  value?.toString().trim().replace(/^@+/, '') || '';

// The username lives in social_profiles.whatsapp; social_whatsapp_user_name is the older key
// the WhatsApp identifier sync also writes.
export const whatsappUsernameOf = (additionalAttributes = {}) => {
  const { social_profiles: socialProfiles = {} } = additionalAttributes || {};
  return normalizeWhatsAppUsername(
    socialProfiles?.whatsapp || additionalAttributes?.social_whatsapp_user_name
  );
};
